import { Module } from '@nestjs/common';
import { NovasisPayModule } from 'src/novasis-pay/novasis-pay.module';
import { EcommerceModule } from 'src/ecommerce/ecommerce.module';
import { EcommerceNotificationsModule } from 'src/ecommerce/notifications/ecommerce-notifications.module';
import { OfertasModule } from 'src/ofertas/ofertas.module';
import { StorePublicController } from './store-public.controller';
import { StorePublicService } from './store-public.service';

@Module({
  // EcommerceModule aporta EcommercePedidosService: el sync lazy de pago debe
  // crear el pedido ERP + reservar stock, no sólo cambiar el estado.
  // OfertasModule aporta el motor de evaluación de ofertas (mismo usado en POS).
  imports: [NovasisPayModule, EcommerceModule, EcommerceNotificationsModule, OfertasModule],
  controllers: [StorePublicController],
  providers: [StorePublicService],
})
export class StorePublicModule {}
